var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"grassmaker"},_vm._l((_vm.total),function(n){return _c('Grass',{key:n,ref:("grass_" + n),refInFor:true,attrs:{"num":n,"pattern":_vm.pattern[n-1],"growPos":_vm.growPos_update(_vm.growPos, n)}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }